import { render, staticRenderFns } from "./StatisticProjectReportsBlank.vue?vue&type=template&id=119d34a8&scoped=true&"
import script from "./StatisticProjectReportsBlank.vue?vue&type=script&lang=js&"
export * from "./StatisticProjectReportsBlank.vue?vue&type=script&lang=js&"
import style0 from "./StatisticProjectReportsBlank.vue?vue&type=style&index=0&id=119d34a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119d34a8",
  null
  
)

export default component.exports